import { SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Input } from 'antd';

import { IToken } from 'store/ducks/globalTypes';
import TextBox from 'components/TextBox';

export const StyledAntInput = styled(Input)`
  width: 160px;
  margin-left: 8px;
`;

export const StyledSearchInput = styled(Input)`
  width: 160px;
`;

export const ColumnHeaderContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 8px;
`;

export const InterpretationBaselineHeading = styled.span`
  min-width: 380px;
  display: inline-block;
  margin-left: -70px;
`;

export const SearchContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-left: 50px;
`;

export const SearchIcon = styled(SearchOutlined)`
  font-size: 18px;
  cursor: pointer;
  margin-left: 70px;

  &:hover {
    opacity: 0.7;
  }
`;

export const SearchInput = styled.input`
  width: 200px;
  height: 24px;
  margin-left: 10px;
  font-size: 12px;
  padding: 2px 6px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;

  &:focus {
    outline: none;
    border-color: #1890ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`;

export const ContentWrapper = styled('div')<IToken>`
  width: 100%;
  padding: ${(props) => `${props.token.paddingLG}px`};

  .ant-table-row-level-0 {
    > .ant-table-cell {
      padding: 0 16px;

      > div {
        padding: 0 16px;
      }
    }
  }

  .ant-table-content {
    border-radius: 10px;
  }

  .ant-table-tbody > tr > td {
    padding: 16px !important;
  }

  .ant-table-tbody > tr > td:nth-child(2) {
  }

  .ant-table-tbody > tr > td:nth-child(2) > div {
    min-height: 57px;
    display: flex;
    align-items: center;
  }
  .ant-table-thead tr .ant-table-cell {
    white-space: nowrap;
  }

  .ant-tabs-nav {
    margin: unset;

    &::before {
      border-bottom: unset;
    }
  }

  .ant-tabs {
    .ant-tabs-nav-list {
      gap: 10px;
    }

    .ant-tabs-tab {
      color: ${(props) => props.token.colorPrimaryText};
      font-weight: bold;

      &.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: ${(props) => props.token.colorPrimaryText};
      }
    }
  }

  .ant-tabs-card {
    &.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active {
      background: ${(props) => props.token.colorPrimaryBgHover};
    }

    & > .ant-tabs-nav .ant-tabs-tab {
      background-color: #34899c;
      border: unset;

      &:hover,
      &:focus,
      &:active {
        background: ${(props) => props.token.colorPrimaryBgHover};
      }
    }
  }

  /* Force white icons for all delete buttons in Solution Definition - Deep Navy Theme specific */
  .anticon-delete,
  .ant-btn .anticon-delete,
  .ant-btn-circle .anticon-delete,
  .ant-btn-primary .anticon-delete {
    color: #ffffff !important;
  }

  /* Force white for all icons in buttons */
  .ant-btn .anticon,
  .ant-btn-circle .anticon,
  .ant-btn-primary .anticon {
    color: #ffffff !important;
  }

  /* Specific targeting for TextAreaBoxSolutions delete icons */
  .ant-table-expanded-row .anticon-delete,
  .nested-table .anticon-delete {
    color: #ffffff !important;
  }
`;

export const TextBoxContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: unset !important;
`;

export const StyledTextBox = styled(TextBox)`
  visibility: hidden;
`;

export const CheckboxContainer = styled('div')`
  min-width: 116px;
  margin-right: 16px;
  display: flex;
  justify-content: flex-start;
`;

export const ButtonContainer = styled('div')<{
  withCheckbox?: boolean;
}>`
  min-width: 367px;
  display: flex;
  justify-content: center;
`;

export const EditableTextArea = styled('div')<{ width: number }>`
  width: ${(props) => props.width}px;

  .ant-input {
    width: 100%;
    min-height: 32px;
    resize: vertical;
  }
`;
